import { formatTime } from "@/lib/helpers";
import { Button } from "antd";
import React from "react";
interface TimeButtonProps {
  onClick: () => void;
  time: string;
  isSelected: boolean;
}
const TimeButton = ({ onClick, isSelected, time }: TimeButtonProps) => {
  return (
    <Button
      style={{ width: "100%", fontSize: "12px" }}
      onClick={onClick}
      color="primary"
      variant={"filled"}
    >
      {formatTime(time)}
    </Button>
  );
};

export default TimeButton;
